var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 14,
    fill: "#2C2D3F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_54)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.853 62.7062C124.782 60.2649 122.942 56.8288 122.337 55.7672C122.76 54.9784 122.957 54.3782 122.744 53.8984C122.515 53.3887 121.988 53.3887 121.816 53.3887C121.498 53.3887 121.094 53.4571 120.625 53.5354C119.54 53.7204 117.937 53.9119 116.626 53.6236C113.94 53.0378 110.261 52.7013 106.532 52.7013C105.57 52.7013 104.664 52.7265 103.855 52.769C100.811 52.9198 95.3527 51.1822 88.3412 48.9301L85.714 48.089C82.2246 46.9763 79.5325 46.4124 77.7141 46.4124C76.7529 46.4124 76.2137 46.5723 75.9149 46.7414C75.7101 46.6691 75.5136 46.6329 75.3282 46.6329C74.3409 46.6329 73.8891 47.6069 73.7185 48.4457C73.1928 48.4003 72.8349 48.7558 72.612 49.0969C71.774 49.0269 71.4025 49.685 71.3696 49.7574L71.3045 49.8886V55.5716C69.6061 56.0736 60.4582 56.7159 53.5149 57.0993C53.7199 56.863 53.8888 56.5976 54.0159 56.3013C54.413 55.3913 54.3217 54.4469 54.1986 53.8723L61.8562 49.8786L61.9119 49.6069C61.923 49.5475 62.1931 48.1617 61.4901 47.1041C61.0037 46.3724 60.2041 46 59.1131 46C58.8 46 58.4498 46.0304 58.0566 46.0991C54.1032 46.7894 38.2347 55.5633 36.7582 56.3831C17.9895 57.2621 6.28459 68.793 6.16674 68.9093L6 69.0796V75.45L6.09946 75.5996C8.39606 79.1463 17.0147 80.7155 24.9604 81.0817C24.8353 80.8873 24.7063 80.6986 24.5899 80.4936C24.4831 80.3084 24.3924 80.1128 24.2951 79.9219C23.3174 77.9991 22.7434 75.7607 22.7434 73.357C22.7434 66.3272 27.5633 60.6074 33.4888 60.6074C39.4137 60.6074 44.2337 66.3272 44.2337 73.357C44.2337 75.2651 43.869 77.0658 43.2347 78.6928C43.1587 78.8864 43.0824 79.0828 42.999 79.2695C42.9116 79.4673 42.8141 79.6574 42.7178 79.8484C50.8374 79.3952 66.9153 79.3203 81.525 79.2548C86.7754 79.2281 91.9066 79.2063 96.5501 79.1661C96.4666 78.984 96.3989 78.7919 96.3222 78.6056C96.2467 78.4183 96.1634 78.2351 96.0944 78.0442C95.503 76.4103 95.1722 74.6093 95.1722 72.7255C95.1722 65.2671 100.287 59.1987 106.571 59.1987C112.857 59.1987 117.97 65.2671 117.97 72.7255C117.97 74.1673 117.775 75.5563 117.421 76.8591C117.358 77.0926 117.282 77.3217 117.207 77.5506C117.136 77.7705 117.063 77.9913 116.983 78.2064C119.424 77.5241 121.34 76.2871 122.675 74.476C125.376 70.812 125.055 65.8758 124.902 63.4988C124.877 63.1907 124.861 62.9173 124.853 62.7062Z",
    fill: "url(#paint0_linear_2_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4842 83.8599C36.2263 83.8599 38.6446 82.35 40.267 80.0264C40.4071 79.8262 40.5574 79.6376 40.6847 79.4257C40.7987 79.237 40.8962 79.0377 40.9979 78.8402C41.8267 77.2419 42.3303 75.3754 42.3303 73.3636C42.3303 67.5651 38.3692 62.8679 33.4842 62.8679C28.5984 62.8679 24.639 67.5689 24.639 73.3636C24.639 75.9081 25.4328 78.2084 26.7018 80.0241C26.8327 80.2139 26.9525 80.4166 27.0956 80.5904C27.2604 80.7954 27.4433 80.9803 27.6212 81.1693C29.1855 82.823 31.2251 83.8599 33.4842 83.8599Z",
    fill: "url(#paint1_linear_2_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4898 78.5915C98.5856 78.779 98.6713 78.9725 98.7751 79.1532C100.49 82.0761 103.335 84 106.567 84C109.969 84 112.929 81.8633 114.606 78.6756C114.712 78.4755 114.797 78.259 114.89 78.0493C114.988 77.8389 115.094 77.6384 115.179 77.4179C115.736 75.9876 116.067 74.4062 116.067 72.7296C116.067 66.5041 111.81 61.4571 106.567 61.4571C101.32 61.4571 97.068 66.5044 97.068 72.7296C97.068 74.6561 97.5133 76.4433 98.2318 78.0301C98.3192 78.2199 98.3966 78.4109 98.4898 78.5915Z",
    fill: "url(#paint2_linear_2_54)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_54",
    x: 2,
    y: 46,
    width: 127,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_54"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_54",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_54",
    x1: 65.5,
    y1: 46,
    x2: 65.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F818D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_54",
    x1: 65.5,
    y1: 46,
    x2: 65.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F818D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_54",
    x1: 65.5,
    y1: 46,
    x2: 65.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F818D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515465"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.aec8484f.svg";
export { ForwardRef as ReactComponent };